export default "__VITE_ASSET__BetHCs1J__"